import { ReactSDKClient } from '@optimizely/react-sdk';
import {
    getOptimizelyFeatureFlag,
    useSelectForcedFeatures
} from '@zoopla/optimizely';

const useOptimizely = (
    optimizely: ReactSDKClient | null,
    featureKey: string
) => {
    const featureFlagOverrides = useSelectForcedFeatures();

    return getOptimizelyFeatureFlag(
        featureKey,
        featureFlagOverrides,
        optimizely
    );
};

export default useOptimizely;
